import React from "react";
import { useField } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const AppPhoneInput = ({ label, showCountryCode = true, className, ...props }) => {
  const [field, meta, helpers] = useField(props);

  return (
    <>
      <PhoneInput
        {...field}
        {...props}
        value={
          field.value
            ? showCountryCode
              ? `${field.value.country_code || ""}${field.value.phone || ""}` // Show country code
              : field.value.phone || "" // Hide country code
            : ""
        }
        onChange={(phone, country) => {
          let countryCode = country.dialCode;

          helpers.setValue({
            phone: phone.startsWith(countryCode) ? phone.slice(countryCode.length) : phone,
            country_code: `+${countryCode}`,
          });
        }}
        inputProps={{
          name: "phone",
        }}
        onBlur={() => helpers.setTouched(true)}
        disableCountryCode={!showCountryCode} // Hides the country code if needed
        inputClass={`nta-phone-input ${meta.touched && meta.error ? "is-invalid" : ""} ${className}`}
      />
      {meta.touched && meta.error && <p className="invalid-feedback d-block">{meta.error.phone}</p>}
    </>
  );
};

export default AppPhoneInput;
